export enum SenderType {
  user = 'USER_SENDER',
  company = 'COMPANY_SENDER',
  matrix = 'MATRIX_SENDER',
  crm = 'CRM_SENDER',
}

export interface MailConfiguration {
  id: string;
  mail: string;
  matrixId: number;
  password: string;
  port: string;
  sender: SenderType;
  senderId: number;
  smtp: string;
  ssl: boolean;
  tls: boolean;
  signature: string;
}

export interface MailConfigurationCreateRequest {
  mail: string;
  password: string;
  port: string;
  sender: SenderType;
  senderId?: number;
  smtp: string;
  ssl: boolean;
  tls: boolean;
  signature: string;
}

export interface MailConfigurationUpdateRequest {
  id: string;
  mail: string;
  password: string;
  port: string;
  sender: SenderType;
  senderId?: number;
  smtp: string;
  ssl: boolean;
  tls: boolean;
  signature: string;
}

export interface MailConfigurationFormValues {
  mail: string;
  password: string;
  port: string;
  smtp: string;
  ssl: boolean;
  tls: boolean;
  signature: string;
}

export interface MailConfigurationVerifyRequest {
  id?: number;
  mail: string;
  password: string;
  port: string;
  smtp: string;
  ssl: boolean;
  tls: boolean;
}
